export default "__VITE_ASSET__DoSbIkd8__"